export default __webpack_public_path__ + "static/media/threads-hero.aa7fbc60.svg";